import _ from 'lodash';
import config from '../../../../app/config';

// Config, list of all flags for the patient
export const patientFlags = [
    {
        shortName: config.gpExpected ? 'EXP' : '111',
        name: '111',
        title: config.gpExpected ? 'GP Expected' : '111',
        enabled: true,
    },
    {shortName: 'F2S', name: 'fitToSit', title: 'Fit to Sit', enabled: true},
    {shortName: 'S&T', name: 'seeAndTreat', title: 'See and Treat', enabled: true},
    {shortName: 'F2S', name: 'transport', title: 'Transport', enabled: config?.transportFlagEnable},
    {shortName: 'SF', name: 'fracture', title: 'Fracture/Suspected Fracture', enabled: config?.fractureFlagEnabled},
    {shortName: 'CAR', name: 'inCar', title: 'In Car', enabled: true},
    {shortName: 'SR', name: 'sr', title: 'Side Room', enabled: true},
    {shortName: 'HPN', name: 'patientName', title: 'Hide Patient Name', enabled: true},
    {shortName: 'MT', name: 'majorTrauma', title: 'Major Trauma', enabled: true},
    {shortName: 'DEC', name: 'deceased', title: 'Deceased patient marker', enabled: true},
    {shortName: 'NBM', name: 'nbm', title: 'Nil by Mouth', enabled: true},
    {shortName: 'RES', name: 'res', title: 'Resus', enabled: true},
    {shortName: 'MAJ', name: 'maj', title: 'Majors', enabled: true},
    {shortName: 'AMB', name: 'amb', title: 'ACA', enabled: true},
    {shortName: 'MIN', name: 'min', title: 'Minor', enabled: true},
    {shortName: 'EmOb', name: 'emob', title: 'EmOb', enabled: config?.emObFlagEnabled},
    {shortName: 'MH', name: 'mh', title: 'Mental Health', enabled: config?.mentalHealthFlagEnabled},
    {shortName: 'BDS', name: 'bedas', title: 'Follow-up / BEDAS', enabled: config?.bedasFlagEnabled},
    {shortName: 'DEM', name: 'dementia', title: 'Dementia', enabled: config?.dementiaFlagEnabled},
    {shortName: 'CVA', name: 'stroke', title: 'Stroke', enabled: config?.strokeFlagEnable},
    {
        shortName: 'ASL',
        name: 'isAttendanceAssaultRelated',
        title: 'Attendance Assault Related',
        enabled: config?.attendanceAssaultRelatedFlagEnabled,
    },
    {shortName: 'EPMA', name: 'jac', title: 'Check EPMA', enabled: config?.enableJACFlag},
    {shortName: 'S&R', name: 'S&R', title: 'Streaming & Redirection', enabled: true},
];

export const getPatientFlagValue = (patient, flagName) => {
    if (patient?.metadata?.patientFlags) {
        const flag = _.find(patient.metadata.patientFlags, {name: flagName});
        return !!flag?.checked;
    }
    return false;
};

export const getPatientFlag = (patient, flagName) => {
    if (patient?.metadata?.patientFlags) {
        const flag = _.find(patient.metadata.patientFlags, {name: flagName});
        return flag || null;
    }
    return null;
};

export const addOrReplace = (arr, object) => {
    let index = _.findIndex(arr, {'name': object.name});
    if (-1 === index) {
        arr.push(object);
    } else {
        arr[index] = object;
    }
};

export const addOrReplaceChangeFlag = (arr, object) => {
    let index = _.findIndex(arr, {'name': object.name});
    if (-1 === index) {
        if (object.checked) {
            arr.push(object);
        }
    } else {
        if (arr[index].checked !== object.checked) {
            arr[index] = object;
        }
    }
};

export const findPatientFlagTitle = (name) => {
    const arr = _.find(patientFlags, {name: name});
    return arr ? arr.title : _.startCase(name);
};

export const findPatientFlagShortname = (name) => {
    const flag = _.find(patientFlags, {name: name});
    return flag?.shortName || '';
};

export const findPatientFlagObject = (name) => {
    return _.find(patientFlags, {name}) || null;
};

export const isFlagDisabled = (name) => {
    if (config?.modules?.patient?.disabledFlags && _.isArray(config?.modules?.patient?.disabledFlags)) {
        return config?.modules?.patient?.disabledFlags.includes(name);
    }
    return false;
};